export default {
    //设置cookie
    setCookie(cname, cvalue, exdays, domain,path) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        let cookie = cname + "=" + cvalue + "; " + expires;
        if (domain) cookie += '; domain=' + domain;
        if (path) cookie += '; path=' + path;
        document.cookie = cookie;
    },
    //获取cookie
    getCookie(cname) {
        let name = cname + "=";
        let arr = document.cookie.split(';');
        for (let i = 0, len = arr.length; i < len; i++) {
            let item = arr[i].trim();
            if (item.indexOf(name) == 0) {
                return item.substr(name.length)
            }
        }
        return "";
    },
    //清除cookie  
    clearCookie(name) {
        setCookie(name, "", -1);
    },
}